module.exports = __webpack_public_path__ + "static/netflix-ccxp-5-c0ab8fbdfde216c5d1ff03d022320900.jpg";